import { render, staticRenderFns } from "./ModalCadastroTurma.vue?vue&type=template&id=0487a9f8"
import script from "./ModalCadastroTurma.vue?vue&type=script&lang=js"
export * from "./ModalCadastroTurma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports